import {
  Component,
  OnInit,
  AfterViewInit,
  ViewChild,
  Input,
  ElementRef,
  ViewEncapsulation,
} from '@angular/core';
import { LocalizationService } from 'src/app/service/localization.service';
import gsap from 'gsap';
import { EndScreenButton, ProgressService } from 'src/app/service/progress.service';
import { TvFeature } from 'src/app/data/enum/tv-feature';
import { getEndScreenCopy } from 'src/app/utils/localization';
import { JsonKeyCode } from 'src/app/data/type/locale-copy-key';
import { Params } from '@angular/router';
import { ParameterService } from 'src/app/service/parameter.service';
import { AnalyticsEvent, triggerEvent } from 'src/app/utils/analytics';
import { CompareButtonLocation } from '../atoms/a02-comparison-button/a02-comparison-button.component';
import { EndScreenCopy } from 'src/app/data/enum/end-screen';
import { environment } from 'src/environments/environment';

const localEvents = {
  [TvFeature.BROWSE_TITLES]: AnalyticsEvent.recapBrowseTitles,
  [TvFeature.RECOMMENDATIONS]: AnalyticsEvent.recapRecommendations,
  [TvFeature.VOICE]: AnalyticsEvent.recapVoice,
  [TvFeature.WATCHLIST]: AnalyticsEvent.recapWatchlist,
};

@Component({
  selector: 'app-c06-end-screen',
  templateUrl: './c06-end-screen.component.html',
  styleUrls: ['./c06-end-screen.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class C06EndScreenComponent implements AfterViewInit, OnInit {
  @ViewChild('endScreenRef') endScreenRef: ElementRef;
  @Input() featureName: TvFeature;
  @Input() set translations(value: EndScreenCopy) {
    if (value) this.updateContent(value);
  }
  @Input() defaultButtons?: Array<EndScreenButton>;

  public modalelement: HTMLDivElement | null;
  public pageButtons: Array<EndScreenButton> = [];
  public titleKey: JsonKeyCode;
  public copyKey: JsonKeyCode;
  public params: Params;
  public baseHref = environment.baseHref;
  public comapreButtonLocation = CompareButtonLocation;

  public copy: Record<string, string>;

  constructor(
    private localizationService: LocalizationService,
    private parameterService: ParameterService,
    private progressService: ProgressService,
  ) {
    this.params = this.parameterService.getParams();
  }

  ngAfterViewInit(): void {
    this.modalelement = this.endScreenRef.nativeElement;
    gsap.set(this.modalelement, { autoAlpha: 0 });
  }

  ngOnInit(): void {
    this.updateContent();
  }

  updateContent(keys?: EndScreenCopy) {
    if (!!keys) {
      this.titleKey = keys.title;
      this.copyKey = keys.copy;
    } else {
      this.titleKey = `END_SCREEN_${this.featureName}_TITLE`;
      this.copyKey = `END_SCREEN_${this.featureName}_COPY`;
    }

    this.copy = getEndScreenCopy(this.localizationService, this.titleKey, this.copyKey);
    this.progressService.setFeatureAsVisited(this.featureName);
    this.pageButtons =
      this.defaultButtons ||
      this.progressService.getEndScreenButtons(this.localizationService, this.featureName);
  }

  handleButtonClick(feature: TvFeature, callback?: Function) {
    if (!callback) triggerEvent(localEvents[feature]);
    else callback();
  }
}
